import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'

interface Props {
  onClick: () => void
}

const CloseButton: React.FC<Props> = ({ onClick }) => (
  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
    <button
      type="button"
      className="bg-white rounded-md text-gray-400 hover:text-gray-500"
      onClick={onClick}
    >
      <span className="sr-only">Close</span>
      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
    </button>
  </div>
)

export default CloseButton
